// src/utils/programs/pricingConstants.js

/**
 * Mapping between pricing_unit_id and code
 */
export const PRICING_UNIT_MAP = {
    1: "per_person",
    2: "per_night",
    3: "per_unit",
};

/**
 * Reverse mapping: code to id
 */
export const PRICING_UNIT_CODE_TO_ID = {
    per_person: 1,
    per_night: 2,
    per_unit: 3,
};

/**
 * Discount type constants
 */
export const DISCOUNT_TYPES = {
    ZERO: "zero",
    AMOUNT: "amount",
    PERCENT: "percent",
};

/**
 * Discount target constants (for program-level discount)
 */
export const DISCOUNT_TARGETS = {
    NONE: "none",
    SELL: "sell",
    COST: "cost",
    BOTH: "both",
};

/**
 * Get pricing unit code from ID
 * @param {number} id - Pricing unit ID
 * @returns {string} - Pricing unit code
 */
export const getPricingUnitCode = (id) => {
    return PRICING_UNIT_MAP[id] || "per_person";
};

/**
 * Get pricing unit ID from code
 * @param {string} code - Pricing unit code
 * @returns {number} - Pricing unit ID
 */
export const getPricingUnitId = (code) => {
    return PRICING_UNIT_CODE_TO_ID[code] || 1;
};
